import style from "./PromotionManagementLayout.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import AdminDateChoice from "../datePicker/AdminDateChoice";
import { useEffect, useState } from "react";
import { requester, adminRequester } from "App";
import TableSearchCard from "routes/table/search/TableSearchCard";
import SingleAdminTable from "../table/SingleAdminTable";
import ToolTip from "components/tooltip/tooltip";
import FlexGrid from "layouts/flex/FlexGrid";
import P from "components/P";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import NiceModal from "@ebay/nice-modal-react";
import { t } from "i18next";
export const limit = 20;

function PromotionManagementLayout(props) {
  const [isMounted, setMounted] = useState(false);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [searchCondition, setSearchCondition] = useState();
  const [reload, setReload] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      adminRequester.getPromotions(
        {
          status: "table",
          ...searchCondition,
          offset: page * limit,
          limit: limit,
        },
        (result) => {
          setCount(result.count);
          setMaxPage(result.count / limit);
          setData(result.promotions);
        }
      );
    }
  }, [page, searchCondition]);
  useEffect(() => {
    if (reload) {
      adminRequester.getPromotions(
        {
          status: "table",
          ...searchCondition,
          offset: page * limit,
          limit: limit,
        },
        (result) => {
          setCount(result.count);
          setMaxPage(result.count / limit);
          setData(result.promotions);
        }
      );
      setReload(false);
    }
  }, [reload]);
  const callback = (searchCondition) => {
    
    setPage(0);
    setSearchCondition(searchCondition);
  };

  const dataCallback = (value) => {
    setData(value);
  };
  const openEdit = ({ row }) => {
    NiceModal.show("promotionEdit", { data: row, setReload: setReload });
  };
  const theader = [
    {
      width: 100,
      text: "No.",
      justifyContent: "flex-start",
      Cell: ({ index }) => index + 1,
    },
    {
      width: 100,
      text: "종류",
      justifyContent: "flex-start",
      code: "type",
      Cell: ({ cell }) => t(cell),
      hover: true,
      cursor: true,
      onClick: openEdit,
    },
    {
      width: 200,
      text: "이름",
      justifyContent: "flex-start",
      code: "title",
      hover: true,
      cursor: true,
      onClick: openEdit,
    },
    {
      width: 500,
      text: "코드",
      justifyContent: "flex-start",
      code: "id",
      hover: true,
      cursor: true,
      onClick: openEdit,
    },
    {
      width: 100,
      text: "상태",
      justifyContent: "flex-start",
      Cell: ({ row }) => {
        const now = new Date();
        if (now.getTime() < new Date(row.start_date).getTime()) return "예정";
        else if (now.getTime() < new Date(row.end_date).getTime())
          return "진행중";
        else return "종료";
      },
    },
    {
      width: 200,
      text: "대상",
      justifyContent: "flex-start",
      cursor: true,
      Cell: ({ row }) => (
        <VerticalFlex alignItems="flex-start">
          {row.type === "event" ? (
            row?.products && row.products?.length > 0 ? (
              <FlexChild width="max-content">
                <ToolTip
                  style={{
                    backgroundColor: "white",
                    padding: 5,
                    borderRadius: 10,
                    zIndex: 10,
                    left: "-25%",
                    width: "fit-content",
                  }}
                  title={
                    <div>
                      <FlexGrid
                        columns={Math.min(row.products.length, 3)}
                        rows={1}
                      >
                        {row.products.map((product) => (
                          <VerticalFlex>
                            <img
                              src={product.thumbnail}
                              alt="t"
                              style={{ width: "5vw", height: "5vw" }}
                            />
                            {product.title}
                          </VerticalFlex>
                        ))}
                      </FlexGrid>
                    </div>
                  }
                >
                  <P>{row.products.length}개 상품</P>
                </ToolTip>
              </FlexChild>
            ) : (
              <FlexChild>
                <P>미지정</P>
              </FlexChild>
            )
          ) : row.type === "discount" ? (
            row?.rule?.conditions && row.rule.conditions.length > 0 ? (
              <FlexChild width="max-content">
                <HorizontalFlex gap={20}>
                  {row.rule.conditions
                    .sort((c1, c2) => c1.type.localeCompare(c2.type))
                    .map((condition) => {
                      switch (condition.type) {
                        case "products": {
                          return (
                            <FlexChild width="max-content" key={condition.id}>
                              <ToolTip
                                style={{
                                  backgroundColor: "white",
                                  padding: 5,
                                  borderRadius: 10,
                                  zIndex: 10,
                                  left: "-25%",
                                  width: "fit-content",
                                }}
                                title={
                                  <div>
                                    <FlexGrid
                                      columns={Math.min(
                                        condition.products.length,
                                        3
                                      )}
                                      rows={1}
                                    >
                                      {condition.products.map((product) => (
                                        <VerticalFlex>
                                          <img
                                            src={product.thumbnail}
                                            alt="t"
                                            style={{
                                              width: "5vw",
                                              height: "5vw",
                                            }}
                                          />
                                          {product.title}
                                        </VerticalFlex>
                                      ))}
                                    </FlexGrid>
                                  </div>
                                }
                              >
                                <P>{condition.products.length}개 상품</P>
                              </ToolTip>
                            </FlexChild>
                          );
                        }
                        case "variants": {
                          return (
                            <FlexChild width="max-content" key={condition.id}>
                              <ToolTip
                                style={{
                                  backgroundColor: "white",
                                  padding: 5,
                                  borderRadius: 10,
                                  zIndex: 10,
                                  left: "-25%",
                                  width: "fit-content",
                                }}
                                title={
                                  <div>
                                    <FlexGrid
                                      columns={Math.min(
                                        condition.variants.length,
                                        3
                                      )}
                                      rows={1}
                                    >
                                      {condition.variants.map((variant) => (
                                        <VerticalFlex>
                                          <img
                                            src={variant.thumbnail}
                                            alt="t"
                                            style={{
                                              width: "5vw",
                                              height: "5vw",
                                            }}
                                          />
                                          {variant.title}
                                        </VerticalFlex>
                                      ))}
                                    </FlexGrid>
                                  </div>
                                }
                              >
                                <P>{condition.variants.length}개 옵션</P>
                              </ToolTip>
                            </FlexChild>
                          );
                        }
                        default:
                          return (
                            <FlexChild>
                              <P>{condition.type}</P>
                            </FlexChild>
                          );
                      }
                    })}
                </HorizontalFlex>
              </FlexChild>
            ) : (
              <FlexChild width="max-content">
                <P color="red">미지정</P>
              </FlexChild>
            )
          ) : (
            <></>
          )}
        </VerticalFlex>
      ),
    },
  ];
  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <TableSearchCard callback={callback} index={5} />
        </FlexChild>
        <FlexChild>
          <SingleAdminTable
            upload
            theader={theader}
            count={count}
            mockData={data}
            initTabIndex={0}
            callback={dataCallback}
            page={page}
            maxPage={maxPage}
            setPage={setPage}
            limit={limit}
          />
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default PromotionManagementLayout;
